<template>
	<div class="container">
		<detail-nav :title="id ? '编辑团购' : '发布团购'" @navigateBack="navigateBack"></detail-nav>
		<el-row>
			<el-col :span="20">
				<el-form class="myform" :model="formData" :rules="formRule" ref="ruleForm" label-width="110px">
					<div class="form-section">基础信息</div>
					<el-form-item label="团购封面" prop="cover">
						<div class="form-item">
							<el-upload class="upload-image" ref="imgUploader"
							  :action="upload.url"
							  :headers="upload.headers"
							  :show-file-list="false"
							  :on-success="uploadSuccess"
							  :before-upload="beforeUpload"
							>
								<div class="uploader-item" v-if="!formData.cover_id">
									<i class="el-icon-plus"></i>
								</div>
								<img :src="formData.cover" class="up-img" v-else>
							</el-upload>
							<p class="up-tip">图片最大不超过1M的jpg、png、jpeg格式的图片，建议图片尺寸750x480px</p>
						</div>
					</el-form-item>

					<el-form-item label="团购名称" prop="title">
						<div class="form-item">
							<el-input class="event-textarea" type="textarea" v-model="formData.title" placeholder="填写团购名称"
								maxlength="30" autosize show-word-limit @input="vInput($event, 'title')">
							</el-input>
						</div>
					</el-form-item>

					<el-form-item label="开始时间" prop="start_time">
						<div class="form-item">
							<el-date-picker type="datetime" :picker-options="date_picker_option" v-model="formData.start_time" value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始时间">
							</el-date-picker>
						</div>
					</el-form-item>

					<el-form-item label="团购周期" prop="cycle">
						<div class="form-item cycles">
							<div class="cycle-item" :class="{'cycle-active': item == formData.cycle}" v-for="item in cycles" @click="changeCycle(item)">{{item}}天</div>
						</div>
					</el-form-item>
					
					<el-form-item label="物流方式" prop="delivery_type">
						<div class="form-item">
							<el-select v-model="formData.delivery_type" placeholder="请选择" @change="changeDelivery">
								<el-option
								      v-for="dt in delivery_type_options"
								      :key="dt.value"
								      :label="dt.label"
								      :value="dt.value">
								</el-option>
							</el-select>
						</div>
					</el-form-item>
					
					<el-form-item label="设置自提点" prop="points" v-if="formData.delivery_type == 4">
						<div class="form-item" style="display: flex;">
							<div class="select_point" @click="open_dialogPoint()">
								<span v-if="check_point_id.length > 0">已选{{check_point_id.length}}个</span>
								<span v-else>选择已有自提点</span>
								<i class="el-icon-arrow-down" style="float:right;margin-top: 12px;"></i>
							</div>
							<div class="pointbtn" @click="pointManger">自提点管理> </div>
						</div>
						<div class="point_blo">
							<div class="_point" v-for="(point, idx) in checkPoints" :key="point.id">
								{{point.name}}
								<i class="el-icon-close" @click="del_point(idx)" style="cursor: pointer;font-weight: bold;margin-left: 7px;color: #999999;"></i>
							</div>
						</div>
					</el-form-item>

					<el-form-item label="团购介绍" prop="remark">
						<div class="form-item" style="line-height: 22px;">
							<quill-editor ref="text" v-model="remark" 
								class="myQuillEditor" :options="editorOption" />
						</div>
					</el-form-item>

					<div class="form-section">团购商品</div>
					<div class="form-table">
						<el-button type="primary" @click="open_dialogVisible()">+团购商品</el-button>
						<el-table :data="tableData" class="goods-table" header-row-class-name="goods-table_header" border :span-method="objectSpanMethod">
							<el-table-column prop="name" label="商品名称" align="center" width="235px">
								<template slot-scope="scope">
									<div style="display: flex;align-items: center;" v-if="scope.row.name">
										<img class="cover" :src="scope.row.cover" alt="">
										<p class="name" style="text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;word-break: break-word;">{{scope.row.name}}</p>
									</div>
								</template>
							</el-table-column>
							<el-table-column prop="limit" label="限购数量" align="center">
								<template slot="header">
									<span class="bt">*</span>
									<span class="tableHeader">限购数量</span>
								</template>
								<template slot-scope="scope">
									<el-input :value="scope.row.limit" placeholder="不限购" maxlength="7" @input="tInput($event, 'limit', scope.$index)">
									</el-input>
								</template>
							</el-table-column>
							<el-table-column prop="name" label="规格名称" align="center" width="134px">
								<template slot-scope="scope">
									<p>{{scope.row.sku_name}}</p>
								</template>
							</el-table-column>
							<el-table-column prop="cost_price" label="原价" align="center">
								<template slot-scope="scope">
									<div>￥{{scope.row.cost_price}}</div>
								</template>
							</el-table-column>
							<el-table-column prop="price" label="活动价格" align="center">
								<template slot="header">
									<span class="bt">*</span>
									<span class="tableHeader">活动价格</span>
								</template>
								<template slot-scope="scope">
									<el-input :value="scope.row.price" placeholder="￥ 0.00" maxlength="7" @input="tInput($event, 'price', scope.$index)">
									</el-input>
								</template>
							</el-table-column>
							<el-table-column prop="stock" label="库存" align="center">
								<template slot-scope="scope">
									{{scope.row.stock}}
								</template>
							</el-table-column>
							<el-table-column label="操作" align="center" width="100px">
								<template slot-scope="scope">
									<div style="padding: 8px 0;cursor: pointer;">
										<i class="el-icon-delete" @click="delItem(scope.$index)"></i>
									</div>
								</template>
							</el-table-column>
						</el-table>
						<p class="edit-tip">温馨提示：团购开始后将不可编辑。</p>
					</div>

					<div class="form-handle">
						<el-button style="width: 110px;" type="primary" @click="save()">{{id ? '保存' : '创建团购'}}</el-button>
					</div>
				</el-form>
			</el-col>
		</el-row>
		
		<el-dialog width="680px;" title="选择商品" :visible.sync="dialogVisible" :before-close="close_dialogVisible" :close-on-click-modal="false" v-loading="shopLoad">
			<div class="product-select">
				<div class="product-select-input el-input el-input-group el-input-group--append">
					<input type="text" 
					  v-model="proKeyWord"
					  @keyup.enter="search_product()"
					  autocomplete="off" placeholder="请输入商品关键词" maxlength="20" class="el-input__inner">
					<div class="el-input-group__append">
						<button type="button" class="el-button product-select-btn el-button--default" @click="search_product()">
							<span>查询</span>
						</button>
					</div>
				</div>
			</div>
			<div v-if="goods.length > 0">
				<div class="pop-list">
					<el-checkbox-group class="goods_checkbox" v-model="goods_checkbox">
						<div class="pop-item" v-for="(item, index) in goods" :key="item.id">
							<el-checkbox :label="item.id"></el-checkbox>
							<img class="pop-cover" :src="item.cover" alt="">
							<div class="pop-info">
								<div class="pro-title" style="text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;overflow: hidden;word-break: break-word;">
									{{item.title}}
								</div>
								<div class="pro-price">
									<div class="price">
										¥{{item.price}}
									</div>
									<div class="stock">
										库存：{{item.stock}}
									</div>
								</div>
							</div>
						</div>
					</el-checkbox-group>
				</div>
				<div style="display: flex;align-items: center;justify-content: space-between;">
					<!-- 分页器 -->
					<div class="block" style="padding: 30px 30px 10px 30px;" v-if="goods.length > 0">
						<el-pagination background align="center" @size-change="handleSizeChange"
							@current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
							layout="total, prev, pager, next" :pager-count="5" :total="total">
						</el-pagination>
					</div>
					<el-button style="width: 110px;margin-top: 20px;" type="primary" @click="add()" :disabled="goods_checkbox.length == 0">确定</el-button>
				</div>
			</div>
			<div class="empty" v-else>
				<img src="../../../assets/img/goods/empty_pop.png">
				<div>没有可选择的商品，您可前往商品库添加商品</div>
			</div>
		</el-dialog>
		
		<dialog-point :show="dialogPointShow" :check_point_id="check_point_id" @close="close_dialogPoint" @success="close_dialogPoint" @confirm="confirmPoint"></dialog-point>
	</div>
</template>

<script>
	import {
		editCombineEvent,
		saveCombineEvent,
		getOnStatusList
	} from '@/api/event';
	import {
		quillEditor,
		Quill
	} from 'vue-quill-editor';
	import {
		handleCode
	} from '@/utils/request';
	import oss from '@/utils/oss';
	import {
		baseURL,
		noPermissionCode
	} from '@/config';
	import detailNav from '@/components/detail-nav.vue';
	import 'quill/dist/quill.core.css';
	import 'quill/dist/quill.snow.css';
	import 'quill/dist/quill.bubble.css';
	import dialogPoint from '@/components/promotion/dialog-point.vue';
	import {
		container,
		ImageExtend,
		QuillWatch
	} from 'quill-image-extend-module'
	
	Quill.register('modules/ImageExtend', ImageExtend)
	
	export default {
		components: {
			detailNav,
			quillEditor,
			dialogPoint
		},
		data() {
			return {
				checkPoints:[], //选中的自提点
				proKeyWord: '',
				id: 0,
				upload: {
					// 请求头
					headers: {
						authorization: this.$store.getters['user/accessToken']
					},
					// 上传地址
					url: baseURL + '/api/brand.Upload/oneToOss'
				},
				date_picker_option:  {
				  // 只能选择30内的日期
				  disabledDate(time) {
					let d30 = (new Date()).getTime() + (30 * 24 * 3600 * 1000);
					return time.getTime() < Date.now() - 8.64e7 || time.getTime() > d30;
				  }
				},
				cycles: [1,3,5,7],
				formData: {
					title: '',
					cover: '',
					cover_id: '',
					start_time: '',
					cycle: '',
					remark: '',
					delivery_type: 4
				},
				formRule: {
					title: [{
						required: true,
						message: '请填写团购名称',
						trigger: 'blur'
					}],
					cover: [{
						required: true
					}],
					start_time: [{
						type: 'date',
						required: true,
						message: '请选择开始时间',
						trigger: 'blur'
					}],
					cycle: [{
						required: true
					}],
					delivery_type: [{
						required: true
					}],
					points: [{
						required: true
					}]
				},
				tableData: [],
				currentPage: 0,
				loading: false,
				shopLoad:false,
				pageSize: 10, // 每页的数据条数
				total: 0,
				goods: [],
				goods_all: [],
				goods_checkbox: [],
				dialogVisible: false,
				previewImageUrl: '',
				showPreviewDialog: false,

				list_page: 0,
				activeName: 'all',
				delivery_type_options: [{
				  value: 4,
				  label: '自提点'
				}, {
				  value: 3,
				  label: '同城配送'
				}],
				dialogPointShow: false, // 自提点弹框
				check_point_id:[], // 选中的自提点id
						
				remark: '', //富文本
				editorOption: {
					placeholder: '填写',
					modules: {
						ImageExtend: {
							loading: true,
							name: 'file', //图片参数名
							size: 5, // 可选参数 图片大小，单位为M，1M = 1024kb
							action: baseURL + '/api/brand.Upload/oneToOss', //上传的服务器地址，如果action为空，则采用base64插入图片
							accept: 'multipart/form-data, image/png, image/gif, image/jpeg, image/bmp, image/x-icon,image/jpg',
							// response 为一个函数，用来获取服务器返回的具体图片地址
							response: res => {
								const imgUrl = res.data.url;
								return imgUrl
							},
							headers: xhr => {
								// 上传图片请求需要携带token的 在xhr.setRequestHeader中设置，这里我的token存放在sessionStorage中
								xhr.setRequestHeader("authorization", this.$store.getters['user/accessToken'] ? this
									.$store.getters['user/accessToken'] : '')
							},
							// 可选参数 设置请求头部
							sizeError: (val) => {
								this.$message.error('请上传5M以内的图片');
				
							}, // 图片超过大小的回调
							start: () => {}, // 可选参数 自定义开始上传触发事件
							end: () => {}, // 可选参数 自定义上传结束触发的事件，无论成功或者失败
							error: () => {}, // 可选参数 上传失败触发的事件
							success: () => {
								var qr = document.getElementsByClassName("ql-editor")[0].getElementsByTagName("img");
								for (var i = 0; i < qr.length; i++) {
									qr[i].style.display = 'block';
									qr[i].style.width = '100%';
								}
							}, // 可选参数  上传成功触发的事件
							change: (xhr, formData) => {
								// xhr.setRequestHeader('myHeader','myValue')
								// formData.append('token', 'myToken')
							} // 可选参数 每次选择图片触发，也可用来设置头部，但比headers多了一个参数，可设置formData
						},
						// 如果不上传图片到服务器，此处不必配置
						toolbar: {
							// container为工具栏，此次引入了全部工具栏，也可自行配置
							container: [
								["bold", "italic", "underline", "strike"],
								["blockquote", "code-block"],
								[{
									header: 1
								}, {
									header: 2
								}],
								[{
									list: "ordered"
								}, {
									list: "bullet"
								}],
								[{
									script: "sub"
								}, {
									script: "super"
								}],
								[{
									indent: "-1"
								}, {
									indent: "+1"
								}],
								[{
									direction: "rtl"
								}],
								[{
									size: ["small", false, "large", "huge"]
								}],
								[{
									header: [1, 2, 3, 4, 5, 6, false]
								}],
								[{
									color: []
								}, {
									background: []
								}],
								[{
									font: []
								}],
								[{
									align: []
								}],
								["image"]
							],
							// 上传成功，回显图片（会进入如上面ImageExtend的各过程，返回<img src="http://xx.xx.xx.xx:xxxx/file/xxx.jpg">）
							handlers: {
								image: function() {
									// 劫持原来的图片点击按钮事件
									QuillWatch.emit(this.quill.id)
								}
							}
						}
					},
				},
			}
		},
		created() {
			let head = document.getElementsByTagName('head');
			let meta = document.createElement('meta');
			//根据实际情况修改referrer的值，可选值参考上文
			meta.name = 'referrer';
			meta.content = 'no-referrer';
			head[0].appendChild(meta);
		},
		destroyed() {
			window.removeEventListener('popstate', this.navigateBack, false);
		},
		mounted() {
			document.getElementsByClassName("father-main")[0].scrollTop = 0;
			let query = this.$route.query;
			if (query.event_id > 0) {
				this.id = query.event_id;
				this.edit();
			}
			if (query.list_page) {
				this.list_page = query.list_page;
			}
			if (query.activeName) {
				this.activeName = query.activeName;
			}
			//监听浏览器返回
			if (window.history && window.history.pushState) {
				// 向历史记录中插入了当前页
				history.pushState(null, null, document.URL);
				window.addEventListener('popstate', this.navigateBack, false);
			}
		},
		methods: {
			// 从数组中移除自提点
			del_point(idx){
				this.checkPoints.splice(idx, 1);
				this.check_point_id.splice(idx, 1);
			},
			// 打开自提点弹框
			open_dialogPoint() {
				this.dialogPointShow = true;
			},
			// 关闭自提点弹框
			close_dialogPoint() {
				this.dialogPointShow = false;
			},
			// 确认选中的自提点
			confirmPoint(e){
				var that = this;
				that.checkPoints = that.checkPoints.concat(e);
				e.forEach(function (j) {
					that.check_point_id.push(j.id);
				})
			},
			// 去自提点管理页面
			pointManger(){
				let pointSrc= this.$router.resolve({
					path: '/customer/point-list',
				});
				          
				// 打开一个新的页面     
				window.open(pointSrc.href, '_blank')
			},
			// 物流方式改变事件
			changeDelivery(e){
				if(e == 3){
					// 显示设置自提点
					this.pointShow = true
				}else{
					this.pointShow = false 
				}
			},
			objectSpanMethod({ row, column, rowIndex, columnIndex }) {
				if (columnIndex === 0) {
					if (this.tableData[rowIndex].rowspan) {
						return {
						  rowspan: this.tableData[rowIndex].rowspan,
						  colspan: 1
						};
					} else {
						return {
						  rowspan: 0,
						  colspan: 0
						};
					}
				} else if (columnIndex === 1) {
					if (this.tableData[rowIndex].rowspan) {
						return {
						  rowspan: this.tableData[rowIndex].rowspan,
						  colspan: 1
						};
					} else {
						return {
						  rowspan: 0,
						  colspan: 0
						};
					}
				} else if (columnIndex === 6) {
					if (this.tableData[rowIndex].rowspan) {
						return {
						  rowspan: this.tableData[rowIndex].rowspan,
						  colspan: 1
						};
					} else {
						return {
						  rowspan: 0,
						  colspan: 0
						};
					}
				}
			},
			formatTableData(data) {
				if (data.length > 0) {
					var newdata = [];
					for (var i = 0;i < data.length;i++) {
						for (var m = 0;m < data[i].sku.length;m++) {
							var data_ = {
								id: data[i].id,
								cover: data[i].cover,
								name: data[i].name,
								limit: data[i].limit ? data[i].limit : '',
								sku_id: data[i].sku[m].id,
								sku_name: data[i].sku[m].name,
								cost_price: data[i].sku[m].cost_price,
								price: data[i].sku[m].price,
								stock: data[i].sku[m].stock
							};
							if (m == 0) data_.rowspan = data[i].sku.length;
							newdata.push(data_);
						}
					}
					return newdata;
				}
			},
			add() {
				if (this.goods_checkbox.length == 0) {
					return false;
				}
				var goods_all = this.goods_all;
				var goods = [];
				this.goods_checkbox.forEach(function (item) {
					for (var i = 0;i < goods_all.length;i++) {
						if (item == goods_all[i].id) {
							goods.push({
								id: goods_all[i].id,
								name: goods_all[i].title,
								cover: goods_all[i].cover,
								sku: goods_all[i].sku,
								limit: ''
							})
							break;
						}
					}
				})
				goods = this.formatTableData(goods);
				this.tableData = this.tableData.concat(goods);
				this.goods_checkbox = [];
				this.proKeyWord = '';
				this.close_dialogVisible();
			},
			// 搜索产品
			search_product(){
				this.shopLoad = true;
				var not_ids = [];
				this.tableData.forEach(function (item) {
					if (not_ids.indexOf(item.id) === -1) not_ids.push(item.id);
				})
				getOnStatusList({
					not_ids: JSON.stringify(not_ids),
					start: 0,
					keyword: this.proKeyWord
				}).then(res => {
					if (res.code == 0) {
						this.shopLoad = false;
						this.total = res.data.count;
						this.goods = res.data.list;
						this.goods_all = res.data.list;
					} else {
						this.$message.error(res.message);
					}
				})
			},
			getOnStatusList() {
				this.shopLoad = true;
				let currentPage = this.currentPage;
				if (currentPage > 0) {
					currentPage = currentPage - 1;
				}
				var not_ids = [];
				this.tableData.forEach(function (item) {
					if (not_ids.indexOf(item.id) === -1) not_ids.push(item.id);
				})
				getOnStatusList({
					not_ids: JSON.stringify(not_ids),
					start: currentPage * 10,
					keyword: this.proKeyWord
				}).then(res => {
					if (res.code == 0) {
						this.shopLoad = false;
						this.total = res.data.count;
						this.goods = res.data.list;
						this.goods_all = this.goods_all.concat(res.data.list)
					} else {
						this.$message.error(res.message);
					}
				})
			},
			//每页条数改变时触发 选择一页显示多少行
			handleSizeChange(val) {
				this.currentPage = 1;
				this.pageSize = val;
			},
			//当前页改变时触发 跳转其他页
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getOnStatusList();
			},
			open_dialogVisible() {
				this.dialogVisible = true;
				this.getOnStatusList();
			},
			close_dialogVisible() {
				this.dialogVisible = false;
			},
			changeCycle(value) {
				this.formData.cycle = value;
			},
			vInput(event, model) {
				var value = '' + event;
				value = value.replace(/\s/g, "");
				switch (model) {
					case 'title':
						this.formData.title = value;
						break;
					case 'remark':
						this.formData.remark = value;
						break;
				}
			},
			tInput(event, model, index) {
				var value = '' + event;
				value = value.replace(/\s/g, "");
				switch (model) {
					case 'price':
						value = num(value);
						this.tableData[index].price = value;
						break;
					case 'limit':
						value = value.replace(/[^\d]/g, "");
						this.tableData[index].limit = value ? Number(value) : '';
						break;
				}
			},
			// 限制用户上传的图片格式和大小
			beforeUpload(file) {
				if (['image/jpeg','image/png','image/gif'].indexOf(file.type) === -1) {
					this.$message.error('上传图片仅支持 JPG、PNG、GIF 格式');
					return false;
				}
				if (file.size / 1024 / 1024 > 1) {
					this.$message.error('上传图片大小不能超过 1MB');
					return false;
				}
				return true;
			},
			// 图片上传完成
			uploadSuccess(response, file, fileList) {
				if (response.code == noPermissionCode) {
					handleCode(response.code, response.message);
				} else {
					this.fileList = fileList;
					this.formData.cover = response.data.url;
					this.formData.cover_id = response.data.id;
				}
				this.$refs.imgUploader.clearFiles(); //上传成功之后清除上传记录
			},
			// 编辑
			edit() {
				editCombineEvent({
					id: this.id
				}).then(res => {
					if (res.code == 0) {
						let data = res.data;
						this.formData.title = data.info.title;
						this.formData.cover = data.info.cover;
						this.formData.cover_id = data.info.cover_id;
						this.formData.start_time = data.info.start_time;
						this.formData.cycle = data.info.cycle;
						this.formData.delivery_type = data.info.delivery_type;
						this.remark = data.info.remark;
						this.tableData = this.formatTableData(data.products);
						this.checkPoints = data.checkPoints;
						var that = this;
						data.checkPoints.forEach(function (j) {
							that.check_point_id.push(j.id);
						})
					} else {
						this.$message.error(res.message);
						setTimeout(() => {
							this.$router.back(-1);
						}, 1500)
					}
				})
			},
			// 保存
			save() {
				if (this.submiting) {
					this.$message.error("正在提交，请勿重复点击");
					return false;
				}
				if (!this.formData.cover_id) {
					this.$message.error("请上传团购封面");
					return false;
				}
				if (this.formData.title.length == 0) {
					this.$message.error("请填写团购名称");
					return false;
				}
				if (this.formData.start_time == '') {
					this.$message.error("请选择开始时间");
					return false;
				}
				if (this.formData.delivery_type == 4 && this.check_point_id.length <= 0){
					this.$message.error("请选择自提点");
					return false;
				}
				if (!this.formData.cycle) {
					this.$message.error("请选择团购周期");
					return false;
				}
				if (this.tableData.length == 0) {
					this.$message.error("请添加团购商品");
					return false;
				}
				let regNeg = /^\d{1,8}(\.\d{0,2})?$/; //负浮点数
				let tableData = this.tableData;
				for (var i in tableData) {
					if (tableData[i] && !(tableData[i]["price"] > 0)) {
						this.$message.error("请设置团购商品活动价格");
						return false;
					}
				}
				
				var remark = this.remark;
				if (remark) {
					remark = format_rich_text__img(remark);
				} else {
					remark = '';
				}
				
				this.submiting = true;
				saveCombineEvent({
					id: this.id,
					type: 2,
					title: this.formData.title,
					cover: this.formData.cover_id,
					start_time: this.formData.start_time,
					cycle: this.formData.cycle,
					remark: trim(remark),
					goods: JSON.stringify(this.tableData),
					delivery_type: this.formData.delivery_type,
					check_point_id: this.check_point_id
				}).then(res => {
					if (res.code == 0) {
						this.$message.success(res.message);
						this.$router.go(-1);
					} else {
						setTimeout(() => {
							this.submiting = false;
						}, 1000)
						this.$message.error(res.message);
					}
				})
			},
			delItem: function(index) {
				this.tableData.splice(index, this.tableData[index].rowspan);
			},
			navigateBack() {
				this.$router.go(-1)
			}
		}
	}
	/**
	 * [只能输入数字和两位小数]
	 * 举例：<input type="text" onkeyup="num(this)" size="10"/>
	 * @param obj
	 * @returns
	 * @data 20019-01-08
	 */
	function num(value) {
		value = value.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
		value = value.replace(/^\./g, ""); //验证第一个字符是数字
		value = value.replace(/\.{2,}/g, "."); //只保留第一个, 清除多余的
		value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
		value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
		var smPric = /^\d{1,8}(\.\d{0,2})?$/;
		if (!smPric.test(value)) {
			return '';
		}
		return value;
	}
	/**
	 * 格式化富文本内容 -> 图片
	 * @params rich_text 富文本原始内容
	 * @return rich_text 格式化后的内容
	 * @author BJ
	 */
	function format_rich_text__img(rich_text) {
		let reg = /<img.+?>/gim;
		let tem = [];
		while (tem = reg.exec(rich_text)) {
			let img_text = tem[0];
			// 设置 width=100%
			if (img_text.indexOf('width="100%"') === -1) {
				let new_img_text = img_text.substr(0, img_text.length - 1) + ' width="100%">';
				rich_text = rich_text.replace(img_text, new_img_text);
				img_text = new_img_text;
			}
			// 设置 display: block
			if (img_text.indexOf('style="') === -1) {
				let new_img_text = img_text.substr(0, img_text.length - 1) + ' style="display: block;">';
				rich_text = rich_text.replace(img_text, new_img_text);
				img_text = new_img_text;
			}
		}
		return rich_text;
	}
	
	/**
	 * 格式化富文本内容 -> 去除首尾换行
	 * @params rich_text 富文本原始内容
	 * @return rich_text 格式化后的内容
	 * @author BJ
	 */
	function trim(rich_text) {
		let reg = /<p><br><\/p>/gim;
		let t = [];
		let arr = [];
		while (t = reg.exec(rich_text)) {
			arr.push(t.index)
		}
		let m = 11;
		let start = 0;
		let end = rich_text.length;
		for (var n = 0; n < arr.length; n++) {
			if (arr[n] != n * m) break;
			start = (n + 1) * m;
		}
		for (var n = arr.length; n > 0; n--) {
			if (arr[n - 1] != rich_text.length - ((arr.length - (n - 1)) * m)) break;
			end = arr[n - 1];
		}
		return rich_text.slice(start, end);
	}
</script>

<style scoped="scoped">
	.product-select{
		margin-bottom: 20px;
	}
	.product-select .product-select-btn{
		width: 100px;
		color: #1989FA;
		background: #E6F1FC;
	}
	
	.goods_checkbox >>> .el-checkbox__label {
		display: none;
	}
	.goods_checkbox >>> .el-checkbox {
		padding: 11px 20px 11px 0;
	}
	
	.event-textarea {
		width: 400px;
		position: relative;
		padding: 0;
	}
	.event-textarea >>> .el-input__count {
		position: absolute;
		left: calc(100% + 5px);
		bottom: 0;
		line-height: 17px;
	}
	
	.container {
		background: #FFFFFF;
		border-radius: 4px;
	}

	.myform {
		padding-bottom: 50px;
	}

	.form-section {
		width: 102px;
		height: 25px;
		margin: 25px 0;
		font-size: 18px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		text-align: center;
		border-left: 3px solid #409EFF;
	}

	.form-item {
		margin-left: 25px;
	}
	.myform >>> .el-form-item__error {
		margin-left: 25px;
	}
	.myform >>> .ql-editor {
		height: 600px;
	}

	.up-tip,
	.edit-tip {
		margin-top: 10px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #999999;
		line-height: 17px;
	}

	.upload-image>>>.el-upload {
		width: 90px;
		height: 90px;
		border: none;
	}

	.up-img {
		width: 90px;
		height: 90px;
		border-radius: 4px;
	}

	.cycles {
		display: flex;
		align-items: center;
	}

	.cycle-item {
		width: 84px;
		height: 40px;
		margin-right: 15px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 40px;
		text-align: center;
		cursor: pointer;
		border-radius: 4px;
		border: 1px solid #DCDFE6;
	}

	.cycle-active {
		color: #1989FA;
		border-color: #0486FE;
	}

	.form-table {
		margin-left: 40px;
	}
	
	.form-table >>> .el-table__expand-icon--expanded {
		display: none;
	}
	.bt {
		color: #F56C6C;
		margin-right: 5px;
	}

	.goods-table {
		margin-top: 20px;
		border-radius: 4px;
		border: 1px solid #DCDFE6;
	}

	.goods-table>>>.goods-table_header th {
		background: rgba(91, 192, 222, 0.1);
	}

	.goods-table>>>.cover {
		width: 40px;
		height: 40px;
		border-radius: 2px;
	}

	.goods-table>>>.name {
		margin-left: 5px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 20px;
		text-align: left;
	}
	
	.form-table>>>.el-table--enable-row-hover .el-table__body tr:hover>td {
	    background-color: #FFFFFF;
	}

	.form-handle {
		margin-top: 30px;
		margin-left: 40px;
	}

	.upload-image {
		position: relative;
		width: 90px;
		height: 90px;
		margin-right: 15px;
	}

	.i_upload-video {
		width: 100%;
		height: 100%;
	}

	.uploader-item {
		width: 90px;
		height: 90px;
		background: #F2F6FC;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 4px;
	}

	.uploader-item .el-icon-plus {
		color: #429FFF;
		font-size: 35px;
		font-weight: bold;
	}
	
	.pop-list {
		height: 300px;
		overflow-y: scroll;
	}
	.pop-item {
		padding: 10px 10px 10px 0;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #EEEEEE;
	}
	.pop-cover {
		width: 40px;
		height: 40px;
		border-radius: 2px;
	}
	.pop-info {
		margin-left: 10px;
	}
	.pro-title {
		width: 470px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 14px;
	}
	.pro-price {
		margin-top: 8px;
		display: flex;
		align-items: center;
	}
	.pro-price .price {
		width: 90px;
		font-size: 14px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #F56C6C;
		line-height: 20px;
	}
	.pro-price .stock {
		margin-left: 10px;
		width: 90px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #666666;
		line-height: 17px;
	}
	.pro-price .rate {
		margin-left: 10px;
		display: flex;
		align-items: center;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #666666;
		line-height: 17px;
	}
	.input-error >>> .el-input__inner, .input-error >>> .el-input__inner:focus {
		border-color: #F56C6C;
	}
	.pop-button {
		margin: 30px 30px 10px;
		padding: 10px 34px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 17px;
		background: #0486FE;
		border-radius: 4px;
		cursor: pointer;
	}
	.empty {
		width: 100%;
		height: 400px;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}
	.empty img {
		width: 126px;
		height: 140px;
	}
	.empty div {
		margin-top: 10px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #999999;
		line-height: 17px;
	}
	
	.form-item >>> .ql-picker-label{
		line-height: 22px;
	}
	.select_point{
		width: 220px;
		height: 40px;
		font-size: 14px;
		color: #606266;
		border-radius: 4px;
		border: 1px solid #DCDFE6;
		padding: 0 12px 0 15px;
		box-sizing: border-box;
		cursor: pointer;
	}
	.pointbtn{
		font-size: 12px;
		color: #0486FE;
		margin-left: 18px;
		cursor: pointer;
	}
	.point_blo{
		padding-left: 25px;
		margin-top: 10px;
	}
	._point{
		height: 32px;
		line-height: 32px;
		background: #F5F5F5;
		border-radius: 4px;
		padding: 0 13px;
		color: #606266;
		font-size: 14px; 
		display: inline-block;
		margin-right: 16px;
		margin-top: 10px;
	}
	
</style>

